export default __webpack_public_path__ + "static/media/timer.630a7fc6.png";